// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__yWie7","icon":"style_icon__15tdK","badge":"style_badge__2-8Tj"};